import { AbstractModel } from '@/models/abstractModel';
import type { IAppAlertRow } from '@/types/appAlert';

export class AppAlertItem extends AbstractModel {
    public code: string;
    public comment: string | null;
    public count: number;
    public createdAt: string;
    public dataId: number | null;
    public dismissToolUserId: number | null;
    public id: number;
    public isDismissedRaw: number;
    public isInvestigateRaw: number;
    public nameId: number;
    public notificationSentAt: string | null;
    public priority: number;
    public priorityId: number | null;
    public text: string | null;
    public typeId: number;
    public uniq: string;
    public uniqAccountId: number | null;
    public uniqBetId: number | null;
    public uniqBetOrderId: number | null;
    public uniqBotId: number | null;
    public uniqEventId: number | null;
    public uniqSiteId: number | null;
    public uniqToolUserId: number | null;
    public updatedAt: string | null;
    public userName: string;

    constructor(data: IAppAlertRow) {
        super();
        this.id = data.id;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at ?? null;
        this.notificationSentAt = data.notification_sent_at ?? null;
        this.typeId = data.type_id;
        this.code = data.code;
        this.uniq = data.uniq;
        this.nameId = data.name_id;
        this.count = data.count;
        this.isDismissedRaw = data.is_dismissed;
        this.isInvestigateRaw = data.is_investigate;
        this.priorityId = data.priority_id ?? null;
        this.text = data.text ?? null;
        this.comment = data.comment ?? null;
        this.uniqToolUserId = data.uniq_tool_user_id ?? null;
        this.uniqSiteId = data.uniq_site_id ?? null;
        this.uniqEventId = data.uniq_event_id ?? null;
        this.uniqBetId = data.uniq_bet_id ?? null;
        this.uniqAccountId = data.uniq_account_id ?? null;
        this.uniqBotId = data.uniq_bot_id ?? null;
        this.uniqBetOrderId = data.uniq_bet_order_id ?? null;
        this.dismissToolUserId = data.dismiss_tool_user_id ?? null;
        this.priority = data.priority;
        this.userName = data.user_name ?? '';
        this.dataId = data.data_id ?? null;
    }

    get isCritical(): boolean {
        return this.priority === 1;
    }

    get isDismissed(): boolean {
        return this.isDismissedRaw === 1;
    }

    get isInvestigate(): boolean {
        return this.isInvestigateRaw === 1;
    }
}
